import { TargetAndTransition, Variants } from "motion/react";
import { PropsWithChildren, ReactElement, useMemo } from "react";

import {
  COLLAPSE_CONTAINER_MAX_HEIGHT,
  COLLAPSE_DURATION_SEC,
} from "@ryde/shared";

import { MotionCollapsableContainerStyled } from "./collapsable-container.styled";

interface ICollapsableContainerProps extends PropsWithChildren {
  maxHeight?: number;
  isSkipMaxHeight?: boolean;
  isCollapsed: boolean;
}

export const CollapsableContainer = ({
  children,
  maxHeight = COLLAPSE_CONTAINER_MAX_HEIGHT,
  isSkipMaxHeight = true,
  isCollapsed,
}: ICollapsableContainerProps): ReactElement => {
  const animate: TargetAndTransition = {
    height: isCollapsed ? "auto" : 0,
    opacity: isCollapsed ? 1 : 0,
  };

  const variants: Variants = useMemo(() => {
    return {
      open: { opacity: 1, height: !isSkipMaxHeight ? maxHeight : 0 },
      collapsed: { opacity: 0, height: 0 },
    };
  }, [isSkipMaxHeight, maxHeight]);

  return (
    <MotionCollapsableContainerStyled
      key="content"
      initial="collapsed"
      animate={!isSkipMaxHeight ? "open" : animate}
      exit="collapsed"
      variants={variants}
      transition={{
        duration: COLLAPSE_DURATION_SEC,
      }}
      style={!isSkipMaxHeight ? { maxHeight: `${maxHeight}px` } : {}}
    >
      {children}
    </MotionCollapsableContainerStyled>
  );
};
